"use client";

import * as React from "react";
import PackeryGrid from "../components/grids/PackeryGrid";
import { gridRowHeights, gridTypesEnum } from "../utils/SchoolBlocksUtilities";
import ClickableLink from "../components/utilities/ClickableLink";
import { withLocaleInURI } from "../internationalization/i18nURI";
import { values } from "mobx";
import { useStores } from "../stores/useStores";
import { observer } from "mobx-react-lite";
import { useT } from "../components/utilities/TranslatedText";

const AlphaCollectionPage: React.FC<{}> = observer(() => {
  const { i18nStore, gridStore, organizationStore } = useStores();
  const t = useT();

  const displayViewStaffButton =
    typeof organizationStore.currentOrganization.json_data.settings
      ?.displayViewStaffButton === "boolean"
      ? organizationStore.currentOrganization.json_data.settings
          .displayViewStaffButton
      : true;

  const isPersonGrid =
    gridStore.blocks.size > 0 &&
    values(gridStore.blocks)[0].blockType === "person";

  return (
    <div id="sb-main-content" className={"sb-teachers-content"}>
      {displayViewStaffButton &&
        organizationStore.currentOrganization.staff_collection && (
          <div className="sb-teachers-search sb-content-width-plus-margin clearfix">
            <ClickableLink
              href={withLocaleInURI(
                "/" +
                  organizationStore.currentOrganization.staff_collection
                    .url_path,
                i18nStore.currentOrgSupportedLocale,
              )}
              id="view-all-staff"
              className="btn btn-primary pull-left"
              style={{ color: "white" }}
            >
              View All{" "}
              {organizationStore.currentOrganization.staff_collection.title}
            </ClickableLink>
          </div>
        )}
      <div id="multiple-grid-container" className="sb-content-width">
        {/*@ts-ignore*/}
        <PackeryGrid
          htmlId={"multiple-grid"}
          gridType={gridTypesEnum.ALPHA_GRID}
          textFilterPlaceholder={
            isPersonGrid ? t("Filter by Title or Name") : t("Filter by Title")
          }
          rowHeight={
            isPersonGrid ? gridRowHeights.person : gridRowHeights.alpha
          }
          key={organizationStore.currentOrganization.id}
          displayFilterByCategory={
            typeof organizationStore.currentOrganization.json_data.settings
              ?.categoryFilter === "boolean"
              ? organizationStore.currentOrganization.json_data.settings
                  .categoryFilter
              : true
          }
          displayFilterByText={
            typeof organizationStore.currentOrganization.json_data.settings
              ?.textFilter === "boolean"
              ? organizationStore.currentOrganization.json_data.settings
                  .textFilter
              : true
          }
        />
      </div>
    </div>
  );
});

export default AlphaCollectionPage;
